<template>
      <div id="staffRequirementForm" class="form">
        <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
          <v-select
            v-model="staffRequirement.staff"
            :items="staffRequirement.relations.staff"
            label="Staff"
            :multiple="false"
            item-text="firstName"
            item-value="id"
            :chips="false"
            deletable-chips
          ></v-select><v-select
            v-model="staffRequirement.requirement"
            :items="staffRequirement.relations.requirement"
            label="Requirement"
            :multiple="false"
            item-text="name"
            item-value="id"
            :chips="false"
            deletable-chips
          ></v-select>
        <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack">
          Back
        </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
        </v-form>
      </div>
    </template>
    
<script>
  import { getStaffRequirement } from "@/services/staffRequirement";
  
              import { getAllStaff } from "@/services/staff";
            
              import { getAllRequirements } from "@/services/requirement";
            
  
  import { mapActions } from "vuex";

  

  export default {
    props: ["id"],
    data () {
      return {
        loaded: false,
        valid: false,
        staffRequirement: {
          relations: {
            staff: [],
requirement: [],

          },
          staff: {},
requirement: {},

        }
      }
    },
    created() {
      this.setInstance();
    },
    methods: {
      ...mapActions("staffRequirement", ["createStaffRequirement", "updateStaffRequirement"]),
      ...mapActions("messages", [
        "addMessage",
        "addErrorMessage",
        "addSuccessMessage"
      ]),
      
      async handleSubmit() {
        if (this.id) {
          let staffRequirement = this.staffRequirement;
          delete staffRequirement.relations;

          this.updateStaffRequirement(staffRequirement)
          .then( (response) => {
            console.log(response);
            this.addSuccessMessage("StaffRequirement was updated successfully");
            this.goBack();
          }).catch( () => {
            this.addErrorMessage("Error updating StaffRequirement, please try again later");
          });
        } else {
          let staffRequirement = this.staffRequirement;
          delete staffRequirement.relations;

          this.createStaffRequirement(staffRequirement)
          .then( response => {
            console.log(response);
            this.addSuccessMessage("StaffRequirement was created successfully");
            this.goBack();
          }).catch( () => {
            this.addErrorMessage("Error creating StaffRequirement, please try again later");
          })
        }
      },
      goBack() {
        this.$router.go(-1);
      },
      setInstance() {
        if (this.id) {
          this.staffRequirement.id = this.id;
          getStaffRequirement(this.id)
            .then(response => {
              let instance = response.data;
              for (let property in instance) {
                if (Object.prototype.hasOwnProperty.call(instance, property) && Object.prototype.hasOwnProperty.call(this.staffRequirement, property)) {
                  this.staffRequirement[property] = instance[property];
                }
              }
              this.loaded = true;
            })
        } else {
          this.loaded = true;
        }
        this.setDependencies();
      },
      setDependencies() {
        
            const params_staff = {
              page: 0,
              size: 100
            };
            getAllStaff(params_staff)
              .then(response => {
                this.staffRequirement.relations.staff = response.data.content;
              });
            
            const params_requirement = {
              page: 0,
              size: 100
            };
            getAllRequirements(params_requirement)
              .then(response => {
                this.staffRequirement.relations.requirement = response.data.content;
              });
            
      }
    },
    components: {
      
    }
  }
</script>
